var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bell") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.43 16.08H1.57C.7 16.08 0 15.37 0 14.51v-.34c0-1.65 1.11-3.05 2.62-3.48V8.38C2.62 3.76 6.38 0 11 0c4.62 0 8.38 3.76 8.38 8.38v2.31c1.51.43 2.62 1.83 2.62 3.48v.34c0 .87-.71 1.57-1.57 1.57zm-18.44-2h18a1.63 1.63 0 00-1.62-1.53c-.55 0-1-.45-1-1V8.38c0-3.52-2.86-6.38-6.38-6.38S4.61 4.86 4.61 8.38v3.17c0 .55-.45 1-1 1-.87 0-1.57.68-1.62 1.53zM11 22c-1.91 0-3.46-1.55-3.46-3.46 0-.55.45-1 1-1s1 .45 1 1c0 .8.65 1.46 1.46 1.46.81 0 1.46-.65 1.46-1.46 0-.55.45-1 1-1s1 .45 1 1c0 1.91-1.55 3.46-3.46 3.46z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.27a573082d472ba311d4f0a521372f22.svg";
export { ForwardRef as ReactComponent };